<template>
    <div>
        <div v-if="title">
            <van-cell class="title_cell" :title="title" :icon="icon" :style="titleStyle"/>
        </div>
        <van-grid :column-num="columnNum" :border="false" :square="square">
            <van-grid-item
                    v-for="(item, index) in list"
                    :key="index"
                    @click="clickItem(item)"
            >

                <div slot="default">
                    <JdSkuInfoSimpleCard :sku-info="item" :img-gray="imgGray"></JdSkuInfoSimpleCard>
                </div>

            </van-grid-item>
        </van-grid>
    </div>
</template>

<script>
    import JdSkuInfoSimpleCard from "./JdSkuInfoSimpleCard";
    export default {
        name: "Wp_grid_data",
        components: {JdSkuInfoSimpleCard},
        props:{
            list:{type: Array},//list = [{"img": "img_url", ...},{}] // [{component: "", id: "", props:{}}]
            columnNum:{type: Number, default: 3},
            round: {type: Boolean, default: false},
            radius: {type: Number, default: 0},
            square: {type: Boolean, default: false},
            icon:{type: String, default: ""},
            title:{type: String, default: ""},
            titleStyle:{type: String, default: ""},
            imgGray:{type: Boolean, default: false}
        },
        data(){
            return{

            }
        },

        methods:{
            clickItem(item){
                this.$emit("clickItem", item)
            }
        }
    }
</script>

<style scoped>
    /deep/ .van-grid-item .van-grid-item__content  {
        background-color: rgba(255, 255, 255, 0);
        padding: 5px;
    }

    .title_cell{
        padding: 0px 1px;
        background-color: rgba(0,0,0,0);
    }

</style>